module.exports = __webpack_public_path__ + "static/media/ThiagoFerreira.1644a5f8.jpg";